import { Footer } from '@pegasus/ui-footers/types/content';

import { API_PREFIX } from '../../../shared/constants';
import { createRestClient, assertStatusCode } from '../../shared/rest';

export interface Response {
    results: Footer;
}

export const fetchFooter = (locale: string): Promise<Response> => {
    const client = createRestClient(API_PREFIX, false);

    return client
        .get(`/footers/${locale}`)
        .then(assertStatusCode([200]))
        .then(response => response.json())
        .then(data => ({
            results: data,
        }));
};
